import React, { Component } from 'react';

import FieldChooser from '../components/FieldChooser';
import ValueInput from '../components/ValueInput';
import UniqueValueChooser from '../components/UniqueValueChooser';
import ValueTypeChooser from '../components/ValueTypeChooser';
import DomainValueChooser from '../components/DomainValueChooser';
import RelativeDateChooser from '../components/RelativeDateChooser';
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { FormControl, Fieldset } from 'calcite-react/Form';
import Panel from 'calcite-react/Panel';

import {
  getDefaultFilterValue,
  getGenericFieldType
} from '../utils/genericUtils';

const formControlStyles = {
  marginBottom: '5px',
  justifyContent: 'flex-end'
};

class BulkEditExpression extends Component {

  constructor (props)
  {
    super(props);
    
    this.state =
    {   
        field: null,
        value: {
            name: '',
            code: ''
          }
    };
  }

  componentWillReceiveProps(nextProps)
  {
    if (nextProps.expressionDef !== this.props.expressionDef)
    {
      this.setState(
        {
            field: nextProps.expressionDef.field,
            value: nextProps.expressionDef.value
        });
    }
  }

  componentDidMount() {
    if (this.props.fields.length === 1)
    {
      const field = this.props.fields[Object.keys(this.props.fields)[0]];
      this.setOptionsFromField(field);
    }
  }

  updateExpression = updates => {
    const id = this.props.id;
    this.props.updateExpression({ ...updates, id });
  };

  getValueElement = expressionDef => {
    const { valueType, field, operator, value } = expressionDef;

    // Operator does not require a value
    if (operator && operator.omitValue) return null;

    // TODO: need to implement this
    if (valueType === 'unique') {
      return <UniqueValueChooser />;
    }

    // NOTE: only supporting coded value domains for now
    if (field && field.domain && field.domain.codedValues) {
      return (
        <DomainValueChooser
          codedValues={field.domain.codedValues}
          selectedValue={value || getDefaultFilterValue(field)}
          onChange={this.handleValueChanged}
        />
      );
    }

    if (operator && operator.relativeDate) {
      return (
        <RelativeDateChooser value={value} onChange={this.handleValueChanged} />
      );
    }

    // Freeform text input (TextField) or non-relative Date input (DatePicker)
    return (
      <ValueInput
        value={value.code}
        type={getGenericFieldType(field && field.type)}
        onChange={this.handleValueChanged}
      />
    );
  };

  removeExpression = () => {
    const id = this.props.id;
    this.props.removeExpression(id);
  };

  handleFieldChanged = field => {
    this.setOptionsFromField(field);
  };

  handleOperatorChanged = operator => {
    this.updateExpression({ operator });
  };

  handleValueChanged = value => {
    this.setState({
        value: value
    }); 

    this.updateExpression({
        field: this.state.field,
        value: value
      });
  };

  handleValueTypeChanged = valueType => {
    this.updateExpression({ valueType });
  };

  setOptionsFromField = field => {
    /*const operator = getValidOperators(field.type)[0];
    const value = getDefaultFilterValue(field);

    this.updateExpression({
      field,
      value,
      operator
    });

    this.setState({
      field,
      value,
      operator
    }); */

    this.setState({
        field: field
    }); 

    this.updateExpression({
        field: field,
        value: this.state.value
      });
  };

  getValueTypeChooser = (valueType, disableUnique) => {
    if (disableUnique) return null;
    return (
      <ValueTypeChooser
        id={this.props.id}
        selectedValueType={valueType}
        onChange={this.handleValueTypeChanged}
      />
    );
  };

  render() {

    if (!this.props.fields) return null;

    const { field } = this.props.expressionDef;
    
    return (
      <Panel style={{ backgroundColor: '#f6fdff' }}>

        <Fieldset name={`expression-${this.props.id}`} horizontal>
        <Table>
        <TableRow>
        <TableCell>
          <FormControl style={{ flex: '1 0 150px', ...formControlStyles }}>
            <FieldChooser
              selectedField={(this.props.fields.length === 1) ? this.props.fields[0] : field}
              fields={this.props.fields}
              onChange={this.handleFieldChanged}
            />
          </FormControl>
          </TableCell>
          <TableCell>
          <FormControl style={{ flex: '1 0 150px', ...formControlStyles }}>
            {this.getValueElement(this.props.expressionDef)}
          </FormControl>
          </TableCell>
          </TableRow>
          </Table>
        </Fieldset>
      
      </Panel>
    );
  }
}

export default BulkEditExpression;
